import React, { Component } from 'react'
import { connect } from 'react-redux'

import BreakingNews from './component'
class BreakingNewsContainer extends Component {
  shouldComponentUpdate (nextProps) {
    if (!nextProps.isCurrentTab) {
      return false
    }
    return true
  }

  render () {
    return (
      <BreakingNews
        url={this.props.filesToDownload[`news${this.props.selectedRound}.png`]}
        sidebarWidth={this.props.sidebarWidth}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  isCurrentTab: state.ui.currentTab === 'BreakingNews',
  currentPage: state.financials.currentPage,
  teamNumber: state.team.id,
  selectedRound: state.game.selectedRound,
  roundNumber: state.game.currentRound,
  sidebarWidth: state.ui.sidebarWidth,
  filesToDownload: state.files.filesToDownload
})

export default connect(mapStateToProps, {

})(BreakingNewsContainer)
